import { API_ENDPOINTS } from '../../config/api.js';
import { makeApiRequest } from '../apiClient.js';

export const companyService = {
  create: async (data) => {
    try {
      const response = await makeApiRequest({
        endpoint: API_ENDPOINTS.CREATE_COMPANY,
        method: 'POST',
        data,
        accessToken: localStorage.getItem('accessToken'),
      });
      return response.data;
    } catch (error) {
      console.error('Create company error:', error);
      throw error;
    }
  },
  getAllCompanies: async () => {
    try {
      const response = await makeApiRequest({
        endpoint: API_ENDPOINTS.GET_COMPANIES,
        method: 'GET',
        accessToken: localStorage.getItem('accessToken'),
      });
      return response.data;
    } catch (error) {
      console.error('Get all companies error:', error);
      throw error;
    }
  },
  getById: async (companyId) => {
    try {
      const response = await makeApiRequest({
        endpoint: API_ENDPOINTS.GET_BY_ID_COMPANY,
        method: 'POST',
        data: { companyId },
        accessToken: localStorage.getItem('accessToken'),
      });
      return response.data;
    } catch (error) {
      console.error('Get group by ID error:', error);
      throw error;
    }
  },
  delete: async (data) => {
    try {
      const response = await makeApiRequest({
        endpoint: API_ENDPOINTS.DELETE_COMPANY,
        method: 'POST',
        data,
        accessToken: localStorage.getItem('accessToken'),
      });
      return response.data;
    } catch (error) {
      console.error('Delete company error:', error);
      throw error;
    }
  },
  update: async (data) => {
    try {
      const response = await makeApiRequest({
        endpoint: API_ENDPOINTS.UPDATE_COMPANY,
        method: 'POST',
        data,
        accessToken: localStorage.getItem('accessToken'),
      });
      return response.data;
    } catch (error) {
      console.error('Delete company error:', error);
      throw error;
    }
  },
};
